import { currencies } from '../src/currencies';
export default currencies;
